export const preferences = {
  mode: "모드",
  text: "텍스트",
  translationFeature: "번역 기능",
};
